import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import EmailVerificationModal from "./register/EmailVerificationModal";
import {
    sendResetCode,
    verifyResetCode,
    resetPassword
} from "../http/api";
import Elips from "../components/reusable/Elips";
import { FaTimes } from "react-icons/fa";

const ForgotPasswordModal = ({ onClose }) => {
    const { t } = useTranslation();

    const ERROR_MESSAGES = {
        EMAIL_NOT_FOUND: t("forgotPassword.emailNotFound"),
        INVALID_CODE: t("forgotPassword.invalidCode"),
        WEAK_PASSWORD: t("forgotPassword.weakPassword"),
        PASSWORD_NOT_MATCH: t("forgotPassword.passwordNotMatch"),
        ERROR: t("forgotPassword.error")
    };

    const [step, setStep] = useState(1);
    const [email, setEmail] = useState("");
    const [emailCode, setEmailCode] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [verificationError, setVerificationError] = useState("");
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [pendingVerification, setPendingVerification] = useState(false);

    const [passwords, setPasswords] = useState({
        newPassword: "",
        confirmPassword: ""
    });

    const getErrorMessage = (message) => {
        return (
            ERROR_MESSAGES[message] ||
            t("forgotPassword.error")
        );
    };

    const sendCode = async () => {
        try {
            setLoading(true);

            await sendResetCode({
                email
            });

            setShowOtpModal(true);

        } catch (err) {
            setError(
                getErrorMessage(err.message)
            );
        } finally {
            setLoading(false);
        }
    };

    const verifyCode = async () => {
        try {
            setPendingVerification(true);
            setVerificationError("");

            await verifyResetCode({
                email,
                code: emailCode
            });

            setShowOtpModal(false);
            setStep(3);

        } catch {
            setVerificationError(
                getErrorMessage("INVALID_CODE")
            );
        } finally {
            setPendingVerification(false);
        }
    };

    const updatePassword = async () => {
        try {
            setLoading(true);

            await resetPassword({
                email,
                newPassword: passwords.newPassword,
                confirmPassword: passwords.confirmPassword
            });

            alert(
                t("forgotPassword.passwordUpdated")
            );

            onClose();

        } catch (err) {
            setError(
                getErrorMessage(err.message)
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay">

            <div className="modal forgot-modal">

                <button
                    type="button"
                    className="forgot-modal-close"
                    onClick={onClose}
                    aria-label="Fermer"
                >
                    <FaTimes />
                </button>

                <h2>
                    {t("forgotPassword.title")}
                </h2>

                {error && (
                    <div className="error-login-message">
                        ✖ {error}
                    </div>
                )}

                {step === 1 && (
                    <>
                        <div className="forgot-icon">
                            📩
                        </div>

                        <p className="forgot-subtitle">
                            {t("forgotPassword.emailSubtitle")}
                        </p>

                        <input
                            className="forgot-input"
                            placeholder={
                                t("forgotPassword.email")
                            }
                            value={email}
                            onChange={(e) =>
                                setEmail(e.target.value)
                            }
                        />

                        <button
                            className="forgot-btn"
                            onClick={sendCode}
                        >
                            {loading
                                ? <Elips />
                                : t("forgotPassword.continue")
                            }
                        </button>
                    </>
                )}

                {step === 3 && (
                    <>
                        <div className="forgot-icon">
                            🔐
                        </div>

                        <p className="forgot-subtitle">
                            {t("forgotPassword.passwordSubtitle")}
                        </p>

                        <input
                            className="forgot-input"
                            type="password"
                            placeholder={
                                t("forgotPassword.newPassword")
                            }
                            value={passwords.newPassword}
                            onChange={(e) =>
                                setPasswords(prev => ({
                                    ...prev,
                                    newPassword: e.target.value
                                }))
                            }
                        />

                        <input
                            className="forgot-input"
                            type="password"
                            placeholder={
                                t("forgotPassword.confirmPassword")
                            }
                            value={passwords.confirmPassword}
                            onChange={(e) =>
                                setPasswords(prev => ({
                                    ...prev,
                                    confirmPassword: e.target.value
                                }))
                            }
                        />

                        <button
                            className="forgot-btn"
                            onClick={updatePassword}
                        >
                            {loading
                                ? <Elips />
                                : t("forgotPassword.update")
                            }
                        </button>

                    </>
                )}

            </div>

            <EmailVerificationModal
                emailVerificationOpen={showOtpModal}
                email={email}
                emailCode={emailCode}
                setEmailCode={setEmailCode}
                verificationError={verificationError}
                pendingRegister={pendingVerification}
                verifyEmailCode={verifyCode}
                setVerificationError={setVerificationError}
            />

        </div>
    );
};

export default ForgotPasswordModal;
